import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/admin/')({
  loader: () => {
    throw redirect({
      to: '/',
    })
  },
})
